import ds from './DataSourceService'

const baseUrl = '/parcels'
const getAll = () => {
  return ds.apiClientThinkHome.get(baseUrl)
}
const getParcelById = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id)
}

const getParcelsForMasterplan = id => {
  return ds.apiClientThinkHome.get(baseUrl + '?masterplanId=' + id)
}

const getPoisForParcel = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/pois')
}

const addParcel = parcel => {
  return ds.apiClientThinkHome.post(baseUrl, parcel)
}

const updateParcel = parcel => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + parcel.id, parcel)
}

const deleteParcel = parcel => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + parcel)
}
const createDefaultPoi = parcel => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/' + parcel.id + '/create-default-poi',
    parcel
  )
}
export default {
  getParcelById,
  getParcelsForMasterplan,
  getPoisForParcel,
  addParcel,
  updateParcel,
  deleteParcel,
  getAll,
  createDefaultPoi
}
